import { useEffect, useState } from "react";
import styles from "./HomePage.module.css";

const CONSENT_KEY = "tbltop-analytics-consent-v1";
const PREFERENCES_EVENT = "tbltop:privacy-preferences";

declare global {
  interface Window { tbltopEnableAnalytics?: () => boolean; }
}

function storedChoice(): "accepted" | "refused" | undefined {
  try {
    const value = localStorage.getItem(CONSENT_KEY);
    return value === "accepted" || value === "refused" ? value : undefined;
  } catch { return undefined; }
}

export function openCookiePreferences() {
  window.dispatchEvent(new Event(PREFERENCES_EVENT));
}

/** A small first-party choice surface: analytics is never enabled by default. */
export function CookieConsent() {
  const [visible, setVisible] = useState(() => !storedChoice());
  useEffect(() => {
    const open = () => setVisible(true);
    window.addEventListener(PREFERENCES_EVENT, open);
    return () => window.removeEventListener(PREFERENCES_EVENT, open);
  }, []);
  if (!visible) return null;

  const choose = (choice: "accepted" | "refused") => {
    try { localStorage.setItem(CONSENT_KEY, choice); } catch { /* The in-memory choice still applies for this visit. */ }
    if (choice === "accepted") window.tbltopEnableAnalytics?.();
    setVisible(false);
  };

  return <section className={styles.cookieConsent} role="dialog" aria-modal="false" aria-labelledby="cookie-consent-title">
    <div>
      <p className={styles.cookieEyebrow}>Privacy</p>
      <h2 id="cookie-consent-title">Analytics are your choice.</h2>
      <p>We use local storage to make TBLTOP work. With your permission, we also use Google Analytics to understand visits to the public site. You can refuse without limiting TBLTOP.</p>
      <a href="https://dnai.ca/en/privacy-policy" target="_blank" rel="noreferrer">DNAi privacy policy</a>
    </div>
    <div className={styles.cookieActions}>
      <button type="button" className={styles.cookieRefuse} onClick={() => choose("refused")}>Refuse analytics</button>
      <button type="button" className={styles.cookieAccept} onClick={() => choose("accepted")}>Accept analytics</button>
    </div>
  </section>;
}
